import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const AllAgentsList = ({ onAgentClick }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [filterStatus, setFilterStatus] = useState('all');
  const [sortField, setSortField] = useState('name');
  const [sortDirection, setSortDirection] = useState('asc');

  const allAgents = [
    {
      id: 'AGT-001',
      name: 'Michael Johnson',
      location: 'New York, NY',
      email: 'michael.j@agents.com',
      phone: '+1 (555) 123-4567',
      status: 'active',
      volume: 450000,
      transfers: 287,
      customers: 45,
      revenue: 9200,
      commissionRate: 2.5,
      complianceScore: 96,
      kycStatus: 'verified',
      lastActive: '2025-11-27T10:30:00',
      joinedDate: '2023-06-15',
      isLocked: false
    },
    {
      id: 'AGT-002',
      name: 'Sarah Williams',
      location: 'Los Angeles, CA',
      email: 'sarah.w@agents.com',
      phone: '+1 (555) 234-5678',
      status: 'active',
      volume: 380000,
      transfers: 312,
      customers: 52,
      revenue: 7800,
      commissionRate: 2.3,
      complianceScore: 94,
      kycStatus: 'verified',
      lastActive: '2025-11-27T09:15:00',
      joinedDate: '2023-08-22',
      isLocked: false
    },
    {
      id: 'AGT-003',
      name: 'Robert Chen',
      location: 'San Francisco, CA',
      email: 'robert.c@agents.com',
      phone: '+1 (555) 345-6789',
      status: 'active',
      volume: 520000,
      transfers: 198,
      customers: 38,
      revenue: 10600,
      commissionRate: 2.8,
      complianceScore: 98,
      kycStatus: 'verified',
      lastActive: '2025-11-27T11:45:00',
      joinedDate: '2023-04-10',
      isLocked: false
    },
    {
      id: 'AGT-004',
      name: 'Maria Rodriguez',
      location: 'Houston, TX',
      email: 'maria.r@agents.com',
      phone: '+1 (555) 456-7890',
      status: 'active',
      volume: 425000,
      transfers: 356,
      customers: 67,
      revenue: 8700,
      commissionRate: 2.4,
      complianceScore: 91,
      kycStatus: 'verified',
      lastActive: '2025-11-27T08:20:00',
      joinedDate: '2023-07-05',
      isLocked: false
    },
    {
      id: 'AGT-005',
      name: 'David Kim',
      location: 'Chicago, IL',
      email: 'david.k@agents.com',
      phone: '+1 (555) 567-8901',
      status: 'active',
      volume: 395000,
      transfers: 245,
      customers: 41,
      revenue: 8100,
      commissionRate: 2.6,
      complianceScore: 95,
      kycStatus: 'verified',
      lastActive: '2025-11-27T10:00:00',
      joinedDate: '2023-05-18',
      isLocked: false
    },
    {
      id: 'AGT-006',
      name: 'Jennifer Martinez',
      location: 'Miami, FL',
      email: 'jennifer.m@agents.com',
      phone: '+1 (555) 678-9012',
      status: 'suspended',
      volume: 285000,
      transfers: 198,
      customers: 32,
      revenue: 5900,
      commissionRate: 2.2,
      complianceScore: 78,
      kycStatus: 'pending',
      lastActive: '2025-11-25T14:30:00',
      joinedDate: '2024-01-12',
      isLocked: true
    },
    {
      id: 'AGT-007',
      name: 'James Wilson',
      location: 'Seattle, WA',
      email: 'james.w@agents.com',
      phone: '+1 (555) 789-0123',
      status: 'active',
      volume: 340000,
      transfers: 223,
      customers: 38,
      revenue: 7200,
      commissionRate: 2.5,
      complianceScore: 92,
      kycStatus: 'verified',
      lastActive: '2025-11-27T07:50:00',
      joinedDate: '2023-09-30',
      isLocked: false
    },
    {
      id: 'AGT-008',
      name: 'Lisa Anderson',
      location: 'Boston, MA',
      email: 'lisa.a@agents.com',
      phone: '+1 (555) 890-1234',
      status: 'active',
      volume: 310000,
      transfers: 267,
      customers: 44,
      revenue: 6500,
      commissionRate: 2.3,
      complianceScore: 88,
      kycStatus: 'verified',
      lastActive: '2025-11-27T09:35:00',
      joinedDate: '2023-11-08',
      isLocked: false
    },
    {
      id: 'AGT-009',
      name: 'Thomas Brown',
      location: 'Phoenix, AZ',
      email: 'thomas.b@agents.com',
      phone: '+1 (555) 901-2345',
      status: 'inactive',
      volume: 125000,
      transfers: 89,
      customers: 18,
      revenue: 2800,
      commissionRate: 2.0,
      complianceScore: 85,
      kycStatus: 'verified',
      lastActive: '2025-11-20T16:20:00',
      joinedDate: '2024-03-22',
      isLocked: false
    },
    {
      id: 'AGT-010',
      name: 'Emily Davis',
      location: 'Philadelphia, PA',
      email: 'emily.d@agents.com',
      phone: '+1 (555) 012-3456',
      status: 'active',
      volume: 365000,
      transfers: 289,
      customers: 51,
      revenue: 7600,
      commissionRate: 2.4,
      complianceScore: 93,
      kycStatus: 'verified',
      lastActive: '2025-11-27T11:10:00',
      joinedDate: '2023-10-14',
      isLocked: false
    }
  ];

  const handleSort = (field) => {
    if (sortField === field) {
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      setSortField(field);
      setSortDirection('asc');
    }
  };

  const filteredAgents = allAgents?.filter(agent => {
    const matchesSearch = agent?.name?.toLowerCase()?.includes(searchTerm?.toLowerCase()) ||
                         agent?.location?.toLowerCase()?.includes(searchTerm?.toLowerCase()) ||
                         agent?.email?.toLowerCase()?.includes(searchTerm?.toLowerCase());
    const matchesStatus = filterStatus === 'all' || agent?.status === filterStatus;
    return matchesSearch && matchesStatus;
  });

  const sortedAgents = [...filteredAgents]?.sort((a, b) => {
    const aValue = a?.[sortField];
    const bValue = b?.[sortField];
    
    if (typeof aValue === 'string') {
      return sortDirection === 'asc' 
        ? aValue?.localeCompare(bValue) 
        : bValue?.localeCompare(aValue);
    }
    
    return sortDirection === 'asc' ? aValue - bValue : bValue - aValue;
  });

  const getStatusBadge = (status) => {
    const statusConfig = {
      active: { bg: 'bg-success/10', text: 'text-success', label: 'Active' },
      suspended: { bg: 'bg-error/10', text: 'text-error', label: 'Suspended' },
      inactive: { bg: 'bg-muted', text: 'text-muted-foreground', label: 'Inactive' }
    };
    const config = statusConfig?.[status] || statusConfig?.active;
    return (
      <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${config?.bg} ${config?.text}`}>
        {config?.label}
      </span>
    );
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    })?.format(amount);
  };

  const formatDate = (dateString) => {
    return new Date(dateString)?.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  };

  return (
    <div className="bg-card border border-border rounded-lg">
      <div className="p-6 border-b border-border">
        <div className="flex items-center justify-between mb-4">
          <div>
            <h3 className="text-lg font-semibold text-foreground flex items-center space-x-2">
              <Icon name="Users" size={20} />
              <span>All Agents Directory</span>
            </h3>
            <p className="text-sm text-muted-foreground mt-1">
              Complete list of all registered agents
            </p>
          </div>
          <div className="flex items-center space-x-3">
            <span className="text-sm text-muted-foreground">
              {sortedAgents?.length} of {allAgents?.length} agents
            </span>
          </div>
        </div>

        {/* Search and Filter */}
        <div className="flex items-center space-x-4">
          <div className="flex-1 relative">
            <Icon name="Search" size={18} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground" />
            <input
              type="text"
              placeholder="Search by name, location, or email..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e?.target?.value)}
              className="w-full pl-10 pr-4 py-2 border border-border rounded-lg bg-background text-foreground focus:outline-none focus:ring-2 focus:ring-primary"
            />
          </div>
          <select
            value={filterStatus}
            onChange={(e) => setFilterStatus(e?.target?.value)}
            className="px-4 py-2 border border-border rounded-lg bg-background text-foreground focus:outline-none focus:ring-2 focus:ring-primary"
          >
            <option value="all">All Status</option>
            <option value="active">Active</option>
            <option value="suspended">Suspended</option>
            <option value="inactive">Inactive</option>
          </select>
        </div>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-muted/50">
            <tr>
              <th 
                className="px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider cursor-pointer hover:text-foreground"
                onClick={() => handleSort('name')}
              >
                <div className="flex items-center space-x-1">
                  <span>Agent</span>
                  <Icon name={sortField === 'name' ? (sortDirection === 'asc' ? 'ChevronUp' : 'ChevronDown') : 'ChevronsUpDown'} size={14} />
                </div>
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                Contact
              </th>
              <th 
                className="px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider cursor-pointer hover:text-foreground"
                onClick={() => handleSort('status')}
              >
                <div className="flex items-center space-x-1">
                  <span>Status</span>
                  <Icon name={sortField === 'status' ? (sortDirection === 'asc' ? 'ChevronUp' : 'ChevronDown') : 'ChevronsUpDown'} size={14} />
                </div>
              </th>
              <th 
                className="px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider cursor-pointer hover:text-foreground"
                onClick={() => handleSort('volume')}
              >
                <div className="flex items-center space-x-1">
                  <span>Volume</span>
                  <Icon name={sortField === 'volume' ? (sortDirection === 'asc' ? 'ChevronUp' : 'ChevronDown') : 'ChevronsUpDown'} size={14} />
                </div>
              </th>
              <th 
                className="px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider cursor-pointer hover:text-foreground"
                onClick={() => handleSort('complianceScore')}
              >
                <div className="flex items-center space-x-1">
                  <span>Compliance</span>
                  <Icon name={sortField === 'complianceScore' ? (sortDirection === 'asc' ? 'ChevronUp' : 'ChevronDown') : 'ChevronsUpDown'} size={14} />
                </div>
              </th>
              <th 
                className="px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider cursor-pointer hover:text-foreground"
                onClick={() => handleSort('lastActive')}
              >
                <div className="flex items-center space-x-1">
                  <span>Last Active</span>
                  <Icon name={sortField === 'lastActive' ? (sortDirection === 'asc' ? 'ChevronUp' : 'ChevronDown') : 'ChevronsUpDown'} size={14} />
                </div>
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                Actions
              </th>
            </tr>
          </thead>
          <tbody className="bg-card divide-y divide-border">
            {sortedAgents?.map((agent) => (
              <tr key={agent?.id} className="hover:bg-muted/30">
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="flex items-center">
                    <div className="flex-shrink-0 h-10 w-10 rounded-full bg-primary/10 flex items-center justify-center">
                      <span className="text-sm font-medium text-primary">
                        {agent?.name?.split(' ')?.map(n => n?.[0])?.join('')}
                      </span>
                    </div>
                    <div className="ml-4">
                      <button
                        onClick={() => onAgentClick(agent)}
                        className="text-sm font-medium text-primary hover:text-primary/80 text-left"
                      >
                        {agent?.name}
                      </button>
                      <div className="text-xs text-muted-foreground flex items-center space-x-1">
                        <Icon name="MapPin" size={12} />
                        <span>{agent?.location}</span>
                      </div>
                    </div>
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="text-sm text-foreground">{agent?.email}</div>
                  <div className="text-xs text-muted-foreground">{agent?.phone}</div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  {getStatusBadge(agent?.status)}
                  {agent?.isLocked && (
                    <div className="flex items-center space-x-1 mt-1">
                      <Icon name="Lock" size={12} className="text-error" />
                      <span className="text-xs text-error">Locked</span>
                    </div>
                  )}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="text-sm font-medium text-foreground">{formatCurrency(agent?.volume)}</div>
                  <div className="text-xs text-muted-foreground">{agent?.transfers} transfers</div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="flex items-center">
                    <div className="flex-1">
                      <div className="text-sm font-medium text-foreground">{agent?.complianceScore}%</div>
                      <div className="w-full bg-muted rounded-full h-1.5 mt-1">
                        <div
                          className={`h-1.5 rounded-full ${
                            agent?.complianceScore >= 95 ? 'bg-success' :
                            agent?.complianceScore >= 85 ? 'bg-warning' : 'bg-error'
                          }`}
                          style={{ width: `${agent?.complianceScore}%` }}
                        />
                      </div>
                    </div>
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="text-sm text-foreground">{formatDate(agent?.lastActive)}</div>
                  <div className="text-xs text-muted-foreground">
                    Joined {formatDate(agent?.joinedDate)}
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                  <button
                    onClick={() => onAgentClick(agent)}
                    className="text-primary hover:text-primary/80 flex items-center space-x-1"
                  >
                    <Icon name="Eye" size={18} />
                    <span>View</span>
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {sortedAgents?.length === 0 && (
        <div className="p-8 text-center">
          <Icon name="Users" size={48} className="mx-auto text-muted-foreground mb-4" />
          <p className="text-muted-foreground">No agents found matching your search criteria</p>
        </div>
      )}
    </div>
  );
};

export default AllAgentsList;